import { render, staticRenderFns } from "./EventChart.vue?vue&type=template&id=a8384764&scoped=true&"
import script from "./EventChart.vue?vue&type=script&lang=js&"
export * from "./EventChart.vue?vue&type=script&lang=js&"
import style0 from "./EventChart.vue?vue&type=style&index=0&id=a8384764&lang=sass&scoped=true&"
import style1 from "./EventChart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8384764",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VCol,VRow,VSkeletonLoader,VSwitch})
